import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { EquipmentCard } from "@/features/resources/EquipmentCard";
import { CardNotFound, CardSkeleton } from "@/features/resources/CardScreens";
import { getEquipment, resourcesKeys } from "@/features/resources/resources.api";
import { hasModule, firstAllowedRoute } from "@/lib/auth";

const SCREEN_LABEL = "Back-office Trailer Card";

export const Route = createFileRoute("/_shell/transport-units/equipment/$id")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "tms_transport_units") && !hasModule(context.session, "tms_resources_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: TrailerScreen,
});

function TrailerScreen() {
  const { id } = Route.useParams();
  const { session } = Route.useRouteContext();
  const canEdit = session.roles.includes("admin") || hasModule(session, "tms_resources_write");

  const query = useQuery({ queryKey: resourcesKeys.equipment(id), queryFn: () => getEquipment(id), retry: false });

  if (query.isPending) return <CardSkeleton screenLabel={SCREEN_LABEL} />;
  if (query.isError || !query.data) return <CardNotFound screenLabel={SCREEN_LABEL} />;

  return (
    <div className="wl-page" data-screen-label={SCREEN_LABEL}>
      <EquipmentCard key={query.data.id} unit={query.data} canEdit={canEdit} />
    </div>
  );
}
